import { useEffect } from "react";
import { useAppSelector } from "@/app/appStore";
import { selectDateRange, selectSelectedOrder } from "@/entities/annotation";
import { isTimeDifferenceOver30Minutes } from "@/features/annotation/lib/helpers";
import { useTimelineData } from "./useTimelineData";
import { useSystemTime } from "./useSystemTime";

export function useSystemTimelineEvent() {
  const selectedOrder = useAppSelector(selectSelectedOrder);
  const dateRange = useAppSelector(selectDateRange);
  const { addTimelineSystemTimeEvent } = useTimelineData();

  const { data: systemTimeData } = useSystemTime();

  useEffect(() => {
    if (
      systemTimeData?.system_datetime &&
      selectedOrder?.time &&
      dateRange.start
    ) {
      const fetchedTime = new Date().toISOString();
      const isDelayed = isTimeDifferenceOver30Minutes(
        selectedOrder.time,
        systemTimeData.system_datetime
      );

      const systemTime = new Date(systemTimeData.system_datetime);
      const isAfterRange = dateRange.end ? systemTime > dateRange.end : false;
      const isBeforeRange = systemTime < dateRange.start;

      addTimelineSystemTimeEvent(
        selectedOrder.id,
        dateRange.start,
        dateRange.end,
        systemTimeData.system_datetime,
        fetchedTime,
        isDelayed,
        isAfterRange,
        isBeforeRange
      );
    }
  }, [
    selectedOrder?.id,
    systemTimeData?.system_datetime,
    selectedOrder?.time,
    addTimelineSystemTimeEvent,
    dateRange.start,
    dateRange.end,
  ]);
}
